/**
 * 全局配置
 */
const global = {
  appId: "wx64da7439b29bc360",
  name: "言韵风华（协会）",
  company: "上海焘韵文化传播有限公司",
  sessionKey: "host-admin-session-key",
  expireTime: "host-admin-expire-time",

  //版本
  version: "0.1",

  //环境，通过请求地址自动判断是否开发环境
  env: window.location.href.startsWith("http://localhost") ? "dev" : "pro",

  //接口服务器
  apiServers: [
    {
      env: "dev",
      url: "/dev-api",  //开发环境下使用代理
      // url: "https://mb.antnas.cn/api",
    },
    {
      env: "pro",
      url: "https://www.taoyun.art/api/",
    },
  ],

  //获取接口地址
  getApiServer(): string {
    let url: string = ""
    this.apiServers.forEach((item: any): void => {
      if (item.env === this.env) url = item.url
    })
    return url
  },

  //获取令牌
  getSessionKey(): string {
    //dev环境下不需要登录
    if (this.env === "dev") {
      return "9b813f5f2c5e8778fcc9e08ca456f41f121486d3641046b50068f4fc05c53610"
    }

    let sessionKey: string | null = localStorage.getItem(this.sessionKey);
    if (sessionKey === 'undefined' || sessionKey == null) {
      return "";
    }

    let expireTime: string | null = localStorage.getItem(this.expireTime);
    if (expireTime != null && new Date().getTime() < Date.parse(expireTime.replace(/-/g, "/"))) {
      return sessionKey;
    }

    return "";
  },

  //保存令牌
  saveSessionKey(sessionKey: string, expireTime: string): void {
    localStorage.setItem(this.sessionKey, sessionKey);
    localStorage.setItem(this.expireTime, expireTime);
  },

  //清空令牌
  clearSessionKey(): void {
    localStorage.removeItem(this.expireTime);
    localStorage.removeItem(this.sessionKey);
  },

  //上传头部
  getUploadHeaders() {
    // "Content-Type": "multipart/form-data;charset=utf-8",
    return {"Session-Key": global.getSessionKey()}
  },

  //获取文件地址
  getFileOpenUrl(data: any) {
    if (data !== null)
      return this.getApiServer() + 'pub/v1/file/open?fileKey=' + encodeURI(data.fileKey) + '&accessKey=' + data.accessKey
    return ''
  },

  /**
   * 转换成分
   *
   * @param amount
   */
  getPenny(amount: any) {
    return Math.round(amount.toFixed(2) * 100);
  },

  /**
   * 获取支付状态颜色
   *
   * @param status
   */
  getPayStatusColor(status: string): string {
    switch (status) {
      case "PAID":
        return "green"
      case "UNPAID":
        return "red"
      case "PAYING":
        return "blue"
      case "REFUNDING":
        return "orange"
      case "REFUNDED":
        return "gray"
      default:
        return "default"
    }
  },

  /**
   * 获取订单状态颜色
   *
   * @param status
   */
  getOrderStatusColor(status: string): string {
    switch (status) {
      case "SUCCESSFUL":
        return "green"
      case "WAITING":
        return "blue"
      case "EXECUTIVE":
        return "orange"
      case "FAILED":
        return "red"
      case "CLOSED":
        return "gray"
      default:
        return "default"
    }
  },

  /**
   * 获取支付状态文本
   *
   * @param status
   */
  getPayStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      "UNPAID": "未支付",
      "PAYING": "支付中",
      "PAID": "已支付",
      "REFUNDING": "退款中",
      "REFUNDED": "已退款"
    }
    return statusMap[status] || status
  },

  /**
   * 获取订单状态文本
   *
   * @param status
   */
  getOrderStatusText(status: string): string {
    const statusMap: { [key: string]: string } = {
      "WAITING": "新订单",
      "EXECUTIVE": "执行中",
      "SUCCESSFUL": "已完成",
      "FAILED": "已失败",
      "CLOSED": "已关闭"
    }
    return statusMap[status] || status
  },

  /**
   * 获取付款状态选项配置
   */
  getPayStatusOptions() {
    return [
      { label: "全部", value: "" },
      { label: "未支付", value: "UNPAID" },
      { label: "支付中", value: "PAYING" },
      { label: "已支付", value: "PAID" },
      { label: "退款中", value: "REFUNDING" },
      { label: "已退款", value: "REFUNDED" }
    ]
  },
}

export default global
